<template>
  <div class="facet is-single">
    <div class="facet-terms">
      <div class="checkbox is-facet-term">
        <input v-model="isActive" type="checkbox" />
        <NuxtLink
          :to="{
            query: {
              [query]: isActive ? undefined : 'true',
            },
          }"
        >
          {{ label }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()

const props = defineProps<{
  query: string
  label: string
}>()

const isActive = computed(() => route.query[props.query] === 'true')
</script>
